'use client'

import { notFound } from 'next/navigation'

import { GameIsAdminOnly } from 'app/components/GameIsAdminOnly'
import { GameToMobileRedirect } from 'app/components/GameToMobileRedirect'
import Layout from 'containers/Layouts/Layout/Layout.client'
import ProductGame from 'pageContainers/ProductGame/desktop'

import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'

type Props = {
  page: any
}

export default function SlotGamePageDesktop({ page }: Props) {
  const { props } = page

  if (!props.gameProduct) {
    notFound()
  }

  if (props.error) {
    return (
      <Layout collapseCurrency collapseMenu>
        <h3>{props.error.toString()}</h3>
      </Layout>
    )
  }

  return (
    <GameIsAdminOnly gameLaunchDate={props.gameProduct.launchDate}>
      <Layout collapseCurrency collapseMenu>
        <GameToMobileRedirect>
          <ProductGame gameProduct={props.gameProduct as GameProduct} currency={props.currency} />
        </GameToMobileRedirect>
      </Layout>
    </GameIsAdminOnly>
  )
}
